module.exports = __webpack_public_path__ + "img/2.65bb129a.png";